import { Link } from 'react-router-dom';

export interface FooterProps {
  xHref: string;
  xHandle: string;
  linkedinHref: string;
  githubHref: string;
  blogHref: string;
  resumeHref: string;
  logoSrc?: string;
}

export function Footer({
  xHref,
  xHandle,
  linkedinHref,
  githubHref,
  blogHref,
  resumeHref,
  logoSrc = '/assets/logo-monogram.svg',
}: FooterProps) {
  const year = new Date().getFullYear();
  return (
    <footer className="foot">
      <div className="wrap foot__row">
        <Link className="brand" to="/">
          <img src={logoSrc} alt="" />
          <b>alison&nbsp;haire<span className="dot">.</span></b>
        </Link>
        <div className="foot__social">
          <a href={xHref} target="_blank" rel="noreferrer noopener">X / @{xHandle}</a>
          <a href={linkedinHref} target="_blank" rel="noreferrer noopener">LinkedIn</a>
          <a href={githubHref} target="_blank" rel="noreferrer noopener">GitHub</a>
          <a href={blogHref} target="_blank" rel="noreferrer noopener">Blog</a>
          <a href={resumeHref} target="_blank" rel="noreferrer noopener">Resume</a>
        </div>
        <small>© {year} Alison Haire · The frontier, shipped. ✦</small>
      </div>
    </footer>
  );
}
